import { IconButton, Typography } from "@mui/material";

import { initializeEncryption } from "../../services/AesGcmEncryption";
import * as CONSTANT from "../../constants/Constant";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2";
import HighlightStats from "../../components/HighlightStats";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import {
  isAuthPageAtom,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";

import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT,
  SOME_ERROR_OCCURRED,
} from "../../constants/Strings";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_TRANSACTION_DETAILS,
  SELECTED_TRANSACTION_TYPE,
  SELECTED_ALL_TRANSACTION,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { saveAs } from "file-saver";

import {
  downloadOnHoldReports,
  getExclusionTransactionList,
  getExclusionTransactionSummary,
} from "../../services/ApiService";
import { useNavigate, useLocation } from "react-router-dom";
import {
    
  exclusionTrasactionListColumnHeader,
} from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import { formatPrice } from "../../utils/PriceFormatter";
import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import DebugLog from "../../utils/DebugLog";

export function RemovedExclusionTrasactionData() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();
  //let selectedAllTransactionDetails = location.state;

  const selectedAllTransactionDetails = location.state && location.state.data;

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [userRole, setUserRole] = useState([]);

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [payoutCycleName, setPayoutCycleName] = useState("");
  const [onHoldHeaderSummary, setOnHoldHeaderSummary] = useState([]);
  const [onHoldSummary, setOnHoldSummary] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);

 
  const [downloadButtonVisible, setDownlaodButton] = useState(false);
 
  const [batchNo, setBatchNo] = useState("");
  let selectedTransactionType = null;
  let selectedTransactionDetailsPageData = null;
  useEffect(() => {
    getUserRole();
    updateButtonVisibility();
    checkPageNavTransactionType()
    getTransactionDetailsPageSelectedRowData();
    checkSelectedTransaction();
  }, []);

  useEffect(() => {

    setBatchNo(selectedAllTransactionDetails?.exclusionTransactionTypes+"")
    setPayoutCycleName(selectedAllTransactionDetails?.exclusionTransactionTypes);

    getHeaderSummary();

    getOnHoldTransactionType(
      paginationModel.page,
      paginationModel.pageSize
    );
  }, []);

  useEffect(() => {
    getDataGridHeight();
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);


  
  function getTransactionDetailsPageSelectedRowData() {
    const storedData = getFromLocalStorageJsonObject(
      SELECTED_TRANSACTION_DETAILS,
      JSON.stringify(selectedTransactionDetailsPageData)
    );
    selectedTransactionDetailsPageData = storedData ? JSON.parse(storedData) : null;
    DebugLog("selectedTransactionDetailsPageData >>>"+selectedTransactionDetailsPageData)
}


  function checkPageNavTransactionType() {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_TRANSACTION_TYPE,
        JSON.stringify(selectedTransactionType)
      );
      selectedTransactionType = storedData ? JSON.parse(storedData) : null;
      DebugLog("selectedTransactionType >>>"+selectedTransactionType)
  }


  
  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Exclusions");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        if (items.buttonName === "DOWNLOAD") {
          setDownlaodButton(true);
        }
      });
    }
  };

  function downloadOnHoldDetails(fileType) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "ON_HOLD_REPORT",
          reportFormat: fileType,
          batchId:batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CREDIT_DEBIT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadOnHoldReports(requestData)
            .then((response) => {
              setLoading(false);


              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, "0");
              const month = String(currentDate.getMonth() + 1).padStart(2, "0");
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `OnHoldReport_${year}-${month}-${day}`;
              switch (fileType) {
                case "CSV":
                  blob = new Blob([response.data], { type: "text/csv" });
                  filename = filename + ".csv";
                  break;
                case "XLS":
                  blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel",
                  });
                  filename = filename + ".xls";
                  break;
                case "PDF":
                  blob = new Blob([response.data], { type: "application/pdf" });
                  filename = filename + ".pdf";
                  break;

                default:
                  throw new Error("Invalid file type");
              }

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedTransaction();

    getOnHoldTransactionType(
      newPage,
      paginationModel.pageSize
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedTransaction();

    getOnHoldTransactionType(
      newPage,
      paginationModel.pageSize
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedTransaction();

    // call api with new page size and start from page 0.
    getOnHoldTransactionType(
      0,
      newPageSize
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }
  function checkSelectedTransaction() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedAllTransactionDetails) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_ALL_TRANSACTION,
        JSON.stringify(selectedAllTransactionDetails)
      );
      selectedAllTransactionDetails = storedData ? JSON.parse(storedData) : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_ALL_TRANSACTION,
        JSON.stringify(selectedAllTransactionDetails)
      );
    }
  }

  /******* API Calls *********/
  async function getHeaderSummary() {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = {
        billingAccountNo: selectedTransactionType.data.billingAccountNo,
        transactionType: selectedAllTransactionDetails.exclusionTransactionTypes,
        companyCode: selectedAllTransactionDetails.companyCode,
      };

      const contentData1 = {
        // billingAccountNo: selectedTransactionType,
        // transactionType: exclusionTransactionTypes,
        // reportDate: reportDate,
        billingAccountNo: "1001",
        transactionType: "MNP - Prepaid Sim Margin",
        companyCode: "A4123",
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.EXCLUSION_TRANSACTION_HEADER_SUMMARY
      );

      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getExclusionTransactionSummary(requestData)
        .then((response) => {
          DebugLog("onHoldHeaderSummary response: " + JSON.stringify(response));
          setOnHoldHeaderSummary(response.data.result);
          setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getOnHoldTransactionType(
    pageNo,
    pageSize
  ) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog


    

      const contentData = {
        billingAccountNo: selectedTransactionType.data.billingAccountNo,
      transactionType: selectedAllTransactionDetails.exclusionTransactionTypes,
      companyCode: selectedAllTransactionDetails.companyCode,
     
        pageNumber: pageNo,
        pageSize: pageSize,
      };

      const contentData1 = {
        billingAccountNo: "1001",
        transactionType: "MNP - Prepaid Sim Margin",
        companyCode: "A4123",
        pageNumber: pageNo,
        pageSize: pageSize,
      };
      
      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.EXCLUSION_TRANSACTION_DATA_LIST
      );

      const payoutSummaryRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getExclusionTransactionList(payoutSummaryRequestData)
        .then((response) => {
          const responseData = response.data.result.exclusionTransactions.content.map((row) => ({
            ...row,
            id: generateRandomId(),
          }));
          setOnHoldSummary(responseData);
          setRowsPerPage(response.data.result.exclusionTransactions.content.length);
          setTotalNoOfRows(response.data.result.exclusionTransactions.totalElements);
          setTotalNoOfPages(response.data.result.exclusionTransactions.totalPages);

          setLoading(false);
          DebugLog(
            "get response.data=====" +
              JSON.stringify(response.data)
          );
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.data != null ? error.data.displayErrorMessage : SOME_ERROR_OCCURRED;
   

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /***** Navigation *******/
  const handleBackClicked = () => {
    getTransactionDetailsPageSelectedRowData()
    //if (selectedAllTransactionDetails.flowFrom === CONSTANT.ON_HOLD_ROUTE) {
      navigate(CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE, {
        state: { data:selectedTransactionDetailsPageData},
      });
    // } else {
    //   navigate(CONSTANT.FINANCE_DASHBOARD);
    // }
  };

  const handleRowClick = (params) => {

    // navigate(CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE, {
    //     state: { data: params.row, type: "0" },
    //   });
  
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />

        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
            <Grid item mr={2}>
              <IconButton onClick={handleBackClicked} width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                {payoutCycleName}
              </Typography>
            </Grid>
          </Grid>
          {/* Header */}
          {/* Highlight Stats */}
          <HighlightStats
            highlightTotal={
              "RM " + formatPrice(onHoldHeaderSummary.total)
            }
            highlight1={"Device Reimbursement"}
            highlight1Stat={
              "RM " + formatPrice(onHoldHeaderSummary.deviceReimbursement)
            }
            highlight2={"Incentives"}
            highlight2Stat={
              "RM " + formatPrice(onHoldHeaderSummary.incentives)
            }
          ></HighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

            {onHoldSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={onHoldSummary}
                  columns={exclusionTrasactionListColumnHeader}
                  // components={{ Toolbar: GridToolbar }}
                  //checkboxSelection
                 // selectionModel={selectedRows}
                 //onSelectionModelChange={handleSelectionChange}
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRowClick}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {onHoldSummary.length > 0 ? (
            <Box item mt={6}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

      
          {/* On Hold Section */}

          {/* Action Buttons */}

          {onHoldSummary.length > 0 ? (
            <Grid item mt={1} justifyContent={"flex-start"} pb={10}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
               

                {downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadOnHoldDetails}
                  />
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          {/* Action Buttons */}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
